import { render, staticRenderFns } from "./DialogCreateOffice.vue?vue&type=template&id=778b1df2"
import script from "./DialogCreateOffice.vue?vue&type=script&lang=ts"
export * from "./DialogCreateOffice.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports